export const SET_CRM_CURRENT_ADVANCE_PAYMENT = 'SET_CRM_CURRENT_ADVANCE_PAYMENT'
